// src/UI/Icon/styles.ts
import styled from "styled-components";

interface StyledSvgProps {
  $width?: number;
  $height?: number;
  $color?: string;
}

export const StyledSvg = styled.svg<StyledSvgProps>`
  display: inline-block;

  /* Если не передали $width, пусть будет 24px */
  width: ${({ $width }) => ($width !== undefined ? $width : 24)}px;
  height: ${({ $height }) => ($height !== undefined ? $height : 24)}px;
  
  object-fit: contain;
  
  /* Если передали $color, используем его, иначе 'inherit' */
  color: ${({ $color }) => $color || "inherit"};
`;
